export const ShelfTypes = {
    ASSET: {label: 'Asset'},
    NETWORK: {label: 'Network'},
    APPLICATION: {label: 'Application'},
    RENTAL: {label: 'Rental'},
    EST_PURCHASES: {label: 'EST purchases'},
    RECOMMENDATION: {label: 'Recommendation'},
};

export const CriterionList = {
    Actor: {
        criterionName: 'Actor',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by actor',
    },
    AirDayOfWeek: {
        criterionName: 'Air Day Of The Week',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by the day of the week on which they aired',
    },
    Amount: {
        criterionName: 'Price $USD',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by price',
    },

    Aliases: {
        criterionName: 'Ams Genre',
        shelfTypes: [ShelfTypes.ASSET],
        description:
            'Filter assets by genre. Genre names that are prefixed with whitespace are enclosed in single quotes.',
    },

    CharacterPage: {
        criterionName: 'Character Page',
        shelfTypes: [ShelfTypes.ASSET, ShelfTypes.NETWORK],
        description:
            'Filter assets/networks to only include those items which start with a letter between the given letters',
    },

    CriticsRating: {
        criterionName: "Critic's Rating",
        shelfTypes: [ShelfTypes.ASSET],
        description: "Filter assets by critic's rating",
    },

    Directors: {
        criterionName: 'Directors',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by director name(s)',
    },

    EchostarId: {
        criterionName: 'Echostar IDs',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by a specific set of Echostar IDs',
    },

    ExtendedAttribute: {
        criterionName: 'Extended Attribute',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Include only recommended, newly released, recently aired, theater release, or new-to-DISH assets',
    },

    Folder: {
        criterionName: 'Featured Folder',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by given folder ID',
    },

    Keyword: {
        criterionName: 'Keyword',
        shelfTypes: [ShelfTypes.ASSET],
        description: "Filter assets by provided keyword in asset's title or description",
    },

    LateNight: {
        criterionName: 'Late Night',
        shelfTypes: [ShelfTypes.ASSET, ShelfTypes.RECOMMENDATION],
        description: 'Whether to include late night content in the results',
    },

    MPAA: {
        criterionName: 'MPAA Rating',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by MPAA rating',
    },

    Network: {
        criterionName: 'Network',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by provided network',
    },

    NetworkTags: {
        criterionName: 'Network Tags',
        shelfTypes: [ShelfTypes.ASSET, ShelfTypes.NETWORK],
        description: 'Filter assets/networks by provided network tags',
    },

    ProductType: {
        criterionName: 'Product Type',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by price (such as free, rental, etc.)',
    },

    RecommendationType: {
        criterionName: 'Recommendation Type',
        shelfTypes: [ShelfTypes.RECOMMENDATION],
        description: 'Filter assets by recommendations.',
    },

    ReleaseDate: {
        criterionName: 'Release Decade',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by release decades',
    },

    ReleaseYear: {
        criterionName: 'Release Year',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by release year',
    },

    Resolution: {
        criterionName: 'Resolution',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by resolution (such as SD, HD, etc.)',
    },

    SeriesID: {
        criterionName: 'Series ID',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets for given Series ID',
    },

    SubTheme: {
        criterionName: 'SubTheme',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by genre (such as comedy, action, family, etc.)',
    },

    Theme: {
        criterionName: 'Theme',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by category (such as movie, TV, or adult)',
    },

    Title: {
        criterionName: 'Title',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by title',
    },

    TVRating: {
        criterionName: 'TV Rating',
        shelfTypes: [ShelfTypes.ASSET],
        description: 'Filter assets by TV rating',
    },
};

export const MovieSubThemeList = [
    {value: 1, label: 'Action'},
    {value: 16777216, label: 'Adventure'},
    {value: 2, label: 'Animated'},
    {value: 4, label: 'Biography'},
    {value: 8, label: 'Comedy'},
    {value: 16, label: 'Crime'},
    {value: 32, label: 'Documentary'},
    {value: 64, label: 'Drama'},
    {value: 128, label: 'Family'},
    {value: 256, label: 'Fantasy'},
    {value: 512, label: 'International'},
    {value: 1024, label: 'Historical'},
    {value: 2048, label: 'Horror'},
    {value: 524288, label: 'Kids: Infant'},
    {value: 1048576, label: 'Kids: Toddler'},
    {value: 2097152, label: 'Kids: 4-6'},
    {value: 4194304, label: 'Kids: 7-10'},
    {value: 8388608, label: 'Kids: 11-13'},
    {value: 4096, label: 'Musical'},
    {value: 8192, label: 'Mystery'},
    {value: 16384, label: 'Romance'},
    {value: 32768, label: 'Science Fiction'},
    {value: 33554432, label: 'Special Interest'},
    {value: 65536, label: 'Suspense'},
    {value: 131072, label: 'War'},
    {value: 262144, label: 'Western'},
];

export const TVSubThemeList = [
    {value: 1, label: 'Action/Adventure'},
    {value: 2, label: 'Animated'},
    {value: 4, label: 'Comedy'},
    {value: 8, label: 'Documentary'},
    {value: 16777216, label: 'Drama'},
    {value: 16, label: 'Educational'},
    {value: 32, label: 'Family'},
    {value: 64, label: 'Health'},
    {value: 128, label: 'Home'},
    {value: 256, label: 'Horror'},
    {value: 524288, label: 'Kids: Infant'},
    {value: 1048576, label: 'Kids: Toddler'},
    {value: 2097152, label: 'Kids: 4-6'},
    {value: 4194304, label: 'Kids: 7-10'},
    {value: 8388608, label: 'Kids: 11-13'},
    {value: 512, label: 'International'},
    {value: 33554432, label: 'Latino'},
    {value: 1024, label: 'Music'},
    {value: 2048, label: 'News'},
    {value: 4096, label: 'Reality'},
    {value: 8192, label: 'Sci-Fi/Fantasy'},
    {value: 16384, label: 'Special Interest'},
    {value: 32768, label: 'Sports'},
    {value: 65536, label: 'Talk & Showbiz'},
    {value: 131072, label: 'Thriller'},
    {value: 262144, label: 'Travel'},
];

export const AdultSubThemeList = [
    {value: 1, label: 'All Action'},
    {value: 2, label: 'Award Winners'},
    {value: 4, label: 'Exotic'},
    {value: 8, label: 'Girl-Girl'},
    {value: 16, label: 'Gonzo Reality'},
    {value: 32, label: 'International'},
    {value: 64, label: 'New Faces'},
    {value: 128, label: 'Older Women'},
    {value: 256, label: 'Pure Sex'},
    {value: 512, label: 'Reality'},
    {value: 32768, label: 'Special Interest'},
    {value: 1024, label: 'Superstars'},
    {value: 2048, label: 'Top Sellers'},
    {value: 4096, label: 'Urban'},
    {value: 8192, label: 'Urban & Ethnic'},
    {value: 16384, label: 'Wild Side'},
];

export const CategoryList = [
    {label: 'Movie', value: 1},
    {label: 'Adult', value: 2},
    {label: 'TV Entertainment', value: 4},
];

export const MpaaRatingList = [
    {value: 'G', label: 'G', bitwiseValue: 1},
    {value: 'PG', label: 'PG', bitwiseValue: 2},
    {value: 'PG13', label: 'PG-13', bitwiseValue: 4},
    {value: 'R', label: 'R', bitwiseValue: 8},
    {value: 'NC17', label: 'NC-17', bitwiseValue: 16},
    {value: 'NR', label: 'NR', bitwiseValue: 64},
    {value: 'NRAO', label: 'NR/AO', bitwiseValue: 32},
];

export const ReleaseDecadeList = [
    {value: 2147483648, label: 'New', decadeName: 'CURRENT_PREVIOUS_YEAR'},
    {value: 1, label: '1890s', decadeName: 'EIGHTEEN_NINETIES'},
    {value: 2, label: '1900s', decadeName: 'NINETEEN_HUNDREDS'},
    {value: 4, label: '1910s', decadeName: 'NINETEEN_TENS'},
    {value: 8, label: '1920s', decadeName: 'NINETEEN_TWENTIES'},
    {value: 16, label: '1930s', decadeName: 'NINETEEN_THIRTIES'},
    {value: 32, label: '1940s', decadeName: 'NINETEEN_FORTIES'},
    {value: 64, label: '1950s', decadeName: 'NINETEEN_FIFTIES'},
    {value: 128, label: '1960s', decadeName: 'NINETEEN_SIXTIES'},
    {value: 256, label: '1970s', decadeName: 'NINETEEN_SEVENTIES'},
    {value: 512, label: '1980s', decadeName: 'NINETEEN_EIGHTIES'},
    {value: 1024, label: '1990s', decadeName: 'NINETEEN_NINETIES'},
    {value: 2048, label: '2000s', decadeName: 'TWO_THOUSANDS'},
    {value: 4096, label: '2010s', decadeName: 'TWENTY_TENS'},
];

export const ResolutionList = [
    {resolutionName: 'SD', searchValue: 1},
    {resolutionName: 'HD1080I', searchValue: 2},
    {resolutionName: 'HD1080P', searchValue: 4},
    {resolutionName: 'FOUR_K', searchValue: 8},
];

export const TypeOfRecommendations = [{label: 'DISH'}, {label: 'AWS'}, {label: 'CONTENTWISE'}, {label: 'DS'}, {label: 'DISHBETA_A'}, {label: 'DISHBETA_B'}];
